import {useTranslations} from "@/hooks/useTranslations.ts";
import {useAlgoliaShopConfig} from "../../providers/AlgoliaShopConfigProvider.tsx";
import {useAutocomplete} from "../providers/AutocompleteProvider.tsx";

export function SearchFieldInitial() {
    const {algoliaConfig: {currentSearch}} = useAlgoliaShopConfig();
    const tc = useTranslations();
    const {setIsModalOpen} = useAutocomplete();
    return (
        <div
            tabIndex={0}
            role="button"
            className="aa-trigger inputGroup searchBar"
            onClick={() => setIsModalOpen(true)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setIsModalOpen(true);
                }
            }}>
			<span className="inputGroup__addon" aria-hidden="true">
				<i className="icon icon-search" aria-hidden={true}/>
			</span>
            <div className="searchBar__dummy">{currentSearch ?? tc.placeholder}</div>
        </div>
    );
}
